import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Target, CheckCircle2, ArrowRight } from "lucide-react";

export function AssignedDrills() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/assignments").then((r) => setItems(r.data.items)).catch(() => {}); }, []);
  const open = items.filter((a) => !a.completed_at);
  const done = items.filter((a) => a.completed_at).slice(0, 2);
  if (!open.length && !done.length) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="rounded-3xl border border-rose-200 bg-gradient-to-br from-rose-50 via-white to-white p-5 shadow-[0_4px_20px_-4px_rgba(244,63,94,0.15)]" data-testid="assigned-drills">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-rose-700"><Target className="w-4 h-4" /> Drills from your manager</div>
      <div className="mt-3 space-y-2">
        {open.map((a) => (
          <Link key={a.id} to={`/app/roleplay?persona=${a.persona_id}`} className="flex items-center gap-3 rounded-2xl bg-white border border-slate-200/80 p-3 hover:border-rose-300 transition-colors" data-testid={`drill-${a.id}`}>
            <img src={a.persona_avatar} alt="" className="w-11 h-11 rounded-xl object-cover object-top" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-slate-900 truncate">Beat {a.target_score} vs {a.persona_title}</div>
              <div className="text-xs text-slate-500 truncate">{a.by_name}{a.note ? ` · “${a.note}”` : ""} · best so far {a.best_rating ?? "—"}</div>
            </div>
            <ArrowRight className="w-4 h-4 text-rose-600 shrink-0" />
          </Link>
        ))}
        {done.map((a) => (
          <div key={a.id} className="flex items-center gap-2 text-xs text-emerald-700 px-1" data-testid={`drill-done-${a.id}`}><CheckCircle2 className="w-4 h-4" /> Completed: {a.persona_title} ({a.best_rating})</div>
        ))}
      </div>
    </motion.div>
  );
}
